<script lang="ts">
    import type { UserCount } from '@/types';
    import type { ChildrenProp } from '@/types/props';

    let { children, counts }: ChildrenProp & { counts: UserCount } = $props();

    let have = $derived(counts?.have ?? '??');
    let total = $derived(counts?.total ?? '??');
    let percent = $derived(counts?.percent || 0);
    let quality = $derived(Math.floor(percent / 25) + 1);
</script>

<style lang="scss">
    span {
        flex: 0 0 auto;
        font-size: 90%;
        font-weight: normal;
        margin-left: 0.5rem;
        word-spacing: -0.2ch;
    }
</style>

<span class="collectible-count">
    <em class="quality{quality}">{have}</em> /
    <em class="quality{quality}">{total}</em>
    {@render children?.()}
</span>
